import React from 'react';
import { useIntl } from 'react-intl';
import { Typography } from '@mui/material';

import { useSettings, Utils } from 'app/main/components';

interface ContractsLinesTableFooterInfoProps {
	totAmount?: number;
}

export default function ContractsLinesTableFooterInfo({ totAmount }: ContractsLinesTableFooterInfoProps) {
	const { t } = useSettings();
	const intl = useIntl();

	return (
		<div className="h-full content-center">
			{(totAmount || totAmount === 0) && (
				<Typography variant="subtitle2">
					{intl.formatMessage(
						{ id: 'contractsLinesTable.totAmount', defaultMessage: t('CONTRACTS_LINES_FOOTER_TOT_AMOUNT') },
						{ value: Utils.formatCurrency(totAmount) }
					)}
				</Typography>
			)}
		</div>
	);
}
